import { toIndianCurrencyHeader } from "../../../MethodMaster/JSXComponentMothod";
import "../DashboardUnique.css";

export default function GrantVillageWiseYojanaDetailHeader({ yojna, handleNavigateToMainTab }) {
  return (
    <div className={"govdash-yojnaDetailHeader"}>
      <div onClick={handleNavigateToMainTab} className={"govdash-detailIconWrapper cursor-pointer"}>
        <i className={`${yojna.IconName} ${"govdash-detailIcon"}`}></i>
      </div>
      <div className={"govdash-detailInfo"}>
        <h2 className={"govdash-detailName"}>{yojna.YojnaName}</h2>
        <div className={"govdash-detailStats"}>
          <div className={"govdash-statItem"}>
            <span className={"govdash-statLabel"}>Grant Details</span>
            <span className={"govdash-statValue"}>{yojna.GrantDetailCount?.toLocaleString()}</span>
          </div>
          {/* {  !!Number(yojna?.TotalAmount || 0) &&<div className={'govdash-statItem'}>
            <span className={'govdash-statLabel'}>Amount</span>
            <span className={'govdash-statValue'}>₹{yojna.TotalAmount?.toLocaleString()}</span>
          </div>} */}
          {!!Number(yojna?.TotalAmount || 0) && (
            <div className={"govdash-statItem"}>
              <span className={"govdash-statLabel"}>Amount</span>
              {/* <span className={'govdash-statValue'}>₹{yojna.TotalAmount?.toLocaleString()}</span> */}
              <span className={"govdash-statValue"}>
                {yojna?.IsYojanaAmount == 1
                  ? `₹${(parseInt(yojna?.YojanaAmount || 0) * parseInt(yojna?.TotalAmount || 0))?.toLocaleString() || ""}`
                  : `₹${yojna?.TotalAmount?.toLocaleString()}`}
                {yojna?.IsYojanaAmount == 1
                  ? toIndianCurrencyHeader(parseInt(yojna?.YojanaAmount || 0) * parseInt(yojna?.TotalAmount || 0))
                  : toIndianCurrencyHeader(parseFloat(yojna?.TotalAmount))}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
